export default __webpack_public_path__ + "static/media/9.9a3464b9.jpeg";